export function ReportProviderSnapshot({ provider }) {
  const rows = [
    ["Provider type", provider.providerType],
    ["Registration position", provider.registrationPosition],
    ["Possible 0115 / 0138 uncertainty", provider.mixedLabel],
    ["Participant scale", provider.participantScale],
    ["Preliminary provider category", provider.preliminaryCategory],
    ["Manual review status", provider.manualReviewStatus]
  ];
  return (
    <div className="overflow-hidden rounded-sm border border-border bg-card">
      <dl className="divide-y divide-border">
        {rows.map(([k, v]) => (
          <div key={k} className="grid grid-cols-1 gap-1 px-5 py-3 sm:grid-cols-3 sm:gap-4">
            <dt className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              {k}
            </dt>
            <dd className="sm:col-span-2 text-[15px] leading-relaxed text-foreground">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
